import React, { useEffect, useState, useMemo, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { BannersIDS, commonBannerApi } from "../../../../utils/commonBannerApi";
import Common_Multiple_Banner from "../../../common_components/common_multiple_banner/Common_Multiple_Banner";
import JobDescriptionModal from "../../JobDescriptionModel/JobDescriptionModal";
import SixthJobMobile from "./SixthJobMobile";
import "./SixthJobTab.css";

const SixthJobTab = () => {
  const [modalShow, setModalShow] = useState(false);
  const [selectedJob, setSelectedJob] = useState({});
  const [applied, setApplied] = useState([]);
  const [imgSrc, setImgSrc] = useState([]);

  const { getData, NoDataAnimations } = useContext(Context);

  const getAppliedJobs = async () => {
    const res = await getData(`/jobseeker/applyed`);
    if (res?.success) {
      setApplied(res.data || []);
    }
  };

  const getBanners = async () => {
    try {
      const res = await commonBannerApi(BannersIDS.JSPAppliedJobs);
      if (res?.success) {
        setImgSrc(res.data || []);
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    getAppliedJobs();
    getBanners();
  }, []);

  const imgSrcNew = useMemo(() => imgSrc.map((item) => item?.image), [imgSrc]);

  const breakpoints = {
    0: { slidesPerView: 1 },
    567: { slidesPerView: 1.2 },
    768: { slidesPerView: 1.5 },
    1024: { slidesPerView: 2 },
  };

  return (
    <>
      <div className="container">
        <div className="applied-jobs-tab-container">
          {/* Header Panel */}
          <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
            <div className="title-section-wrapper">
              <h3 className="dashboard-sub-heading m-0">
                Applied Applications
              </h3>
              <p className="dashboard-sub-meta m-0">
                Track your real-time interview status milestones
              </p>
            </div>
            <Link to="/dashboard-job" className="modern-back-dash-btn">
              <FontAwesomeIcon icon="fa-solid fa-arrow-left" className="me-2" />
              Back to Dashboard
            </Link>
          </div>

          {/* Desktop / Tablet Grid View */}
          <div className="d-none d-md-block">
            <div className="row g-3">
              <div className="col-12">
                {applied?.map((value, index) => (
                  <div
                    className="modern-applied-card mb-3"
                    key={value?.id || index}
                  >
                    <div className="card-primary-row">
                      {/* Left Column: Job Meta Details */}
                      <div className="job-info-block">
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <h4 className="job-role-title m-0">
                            {value?.job?.role?.name}
                          </h4>
                          <span className="badge-applied-pill">
                            Active Application
                          </span>
                        </div>

                        <div className="job-meta-links mt-2">
                          <span className="company-anchor-text">
                            {value?.job?.company?.name}
                          </span>
                          <span className="meta-separator">•</span>
                          <span className="location-meta-text">
                            <FontAwesomeIcon
                              icon="fa-solid fa-location-dot"
                              className="me-1"
                            />
                            {value?.job?.job_work_locations
                              ?.slice(0, 2)
                              .map((type) => type?.city?.name)
                              .join(", ") || "Remote"}
                          </span>
                        </div>
                      </div>

                      {/* Right Column: Dynamic View Action Button */}
                      <div className="action-button-block">
                        <button
                          className="modern-view-details-btn"
                          onClick={() => {
                            setSelectedJob(value?.job);
                            setModalShow(true);
                          }}
                        >
                          View Details
                        </button>
                      </div>
                    </div>

                    {/* Bottom Column: Modern Dynamic Status Timeline Horizontal Map */}
                    {value?.job?.application_status_histories &&
                      value.job.application_status_histories.length > 0 && (
                        <div className="application-timeline-footer mt-3 pt-3">
                          <div className="timeline-scroller-track">
                            {value?.job?.application_status_histories?.map(
                              (status, statusIndex) => (
                                <div
                                  className="timeline-node-step"
                                  key={statusIndex}
                                >
                                  <div className="node-marker-dot"></div>
                                  <div className="node-content-meta">
                                    <span className="node-status-title">
                                      {status?.application_status?.name}
                                    </span>
                                    <span className="node-status-date">
                                      {new Date(
                                        status?.createdAt,
                                      ).toLocaleDateString("en-US", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}
                                    </span>
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      )}
                  </div>
                ))}

                {applied?.length === 0 && (
                  <div className="empty-animation-box py-5 text-center">
                    <NoDataAnimations />
                    <p className="text-muted mt-3">
                      You haven't applied to any positions yet.
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Dynamic Ad Placement Banners inside Desktop layout spacing bounds */}
            {imgSrcNew.length > 0 && (
              <div className="mt-4 pt-2">
                <Common_Multiple_Banner
                  imgSrc={imgSrcNew}
                  breakpoints={breakpoints}
                />
              </div>
            )}
          </div>

          {/* Mobile Nested Fallback Architecture View */}
          <div className="d-block d-md-none mobile-view-cards-stack">
            <SixthJobMobile jobData={applied} />
            {imgSrcNew.length > 0 && (
              <div className="mt-3">
                <Common_Multiple_Banner
                  imgSrc={imgSrcNew}
                  breakpoints={breakpoints}
                />
              </div>
            )}
          </div>

          {/* Modal Interface Viewport Portals */}
          <JobDescriptionModal
            show={modalShow}
            data={selectedJob}
            title={"Job Details & Requirements"}
            onHide={() => setModalShow(false)}
          />
        </div>
      </div>
    </>
  );
};

export default SixthJobTab;
